module.exports = {
    resourceBaseUrl: "http://zhewen.itrax.cn"
}